(function() {
    'use strict';
    angular
        .module('receiptApp')
        .directive('checkAmount', checkAmount);

    checkAmount.$inject = ['$filter', '$locale'];
    function checkAmount ($filter, $locale) {
    	 return {
    	        require: 'ngModel',
    	        restrict: 'A',
    	        scope: {
    	        	equals: '=equals',
    	        	condition: '@condition'
    	        },
    	        link: function(scope, elem, attrs, ctrl) {
    	                scope.$watch(function() {
    	                    var modelValue = ctrl.$modelValue || ctrl.$$invalidModelValue;
    	                    if(scope.condition === '=') {
    	                    	return (ctrl.$pristine && angular.isUndefined(modelValue)) || scope.equals === parseFloat(modelValue);
    	                    }
    	                    if(scope.condition === '<') {
    	                    	return (ctrl.$pristine && angular.isUndefined(modelValue)) || scope.equals < parseFloat(modelValue);
    	                    }
    	                    if(scope.condition === '>') {
    	                    	return (ctrl.$pristine && angular.isUndefined(modelValue)) || scope.equals > parseFloat(modelValue);
    	                    }
    	                }, function(currentValue) {
    	                	console.log(currentValue);
    	                	if(scope.condition === '=') {
    	                		ctrl.$setValidity('amountEquals', currentValue);
    	                	}
    	                	if(scope.condition === '<') {
    	                		ctrl.$setValidity('amountLess', currentValue);
    	                	}
    	                	if(scope.condition === '>') {
    	                		ctrl.$setValidity('amountBigger', currentValue);
    	                	}
    	                    
    	                });
    	            }
    	    };
    }
    
})();

